webpackJsonp([0],{

/***/ 24:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/************************************
	MODULE:         Blog feed
	WHAT IT DOES:   Encapsulates feed layout
	*************************************/
	(function (root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    }
	    else if (typeof exports === 'object') {
	        module.exports = factory(require('jquery'));
	    }
	    else { root.returnExports = factory(root.jQuery); }
	}(this, function ($) {
	
	    function socialfeed(el, settings) {
	        this.container = el;
	
	        $.extend(this, this._defaults);
	        this.settings = $.extend({}, this._settings, this.container.data(), typeof settings != 'undefined' ? settings : {});
	
	        this.init();
	    }
	
	    $.extend(socialfeed.prototype, {
	
	        _settings: {
	            sizeBig:'big',
	            sizeWide: 'wide',
	            sizeSmall: 'small',
	            template: 'single triple tripleReversed single quaternary triple',
	            handlebarsTemplate: 'blogfeedtemplate',
	            url: '',
	            page: 0,
	            total: 0,
	            mintimeout: 1500
	        },
	
	        _defaults: {
	            grid: null,
	            items: null,
	            filter: null,
	            filterdropdown: null,
	            filterChosen: '',
	            loadmore: null,
	            template: null,
	            bigItems: null,
	            wideItems: null,
	            smallItems: null,
	            ajaxCall: null,
	            ajaxTime: null,
	            ajaxTimeout: null,
	            handlebarsTempalteCompiled: null
	        },
	
	        types: {
	            'single': 0,
	            'triple': 1,
	            'double': 2,
	            'tripleReversed' : 3,
	            'quaternary': 4
	        },
	
	        init: function () {
	            this.grid = this.container.find('.js-feed-grid');
	            if(!this.grid.length)
	                return;
	
	            this.items = this.grid.children();
	            this.template = this.settings.template.split(' ');
	
	            var templates = __webpack_require__(247);
	            this.handlebarsTempalteCompiled = templates("./" + this.settings.handlebarsTemplate + ".handlebars");
	
	            this.loadmore = this.container.find('.js-feed-loadmore');
	            this.loadmore.on('click', this.loadNewItems.bind(this, false));
	
	            this.filter = this.container.parent().find(".js-feed-filter");
	            if (this.filter.length) {
	                this.filter.on('click', 'a', this.applyFilter.bind(this));
	                this.filterdropdown = this.container.parent().find('.js-feed-filterdropdown');
	
	                var activeLink = this.filter.find('a.active');
	                if (activeLink.length) {
	                    var chosen = activeLink.attr('data-filter') || '';
	                    if (chosen !== this.filterChosen)
	                        this.filterChosen = chosen;
	                }
	
	                var genericdropdown = __webpack_require__(4);
	                new genericdropdown(this.filterdropdown, {
	                    link: this.filterdropdown.find('.js-dropdown-link'),
	                    content: this.filterdropdown.find('.js-dropdown-content'),
	                    erase: true
	                });
	            }
	
	            __webpack_require__(127);
	
	            this.layout();
	            $(window).on('resize:finished', this.layout.bind(this));
	            document.addEventListener('visibilitychange', this.onVisibilitychanged.bind(this));
	        },
	
	        onVisibilitychanged: function() {
	            var that = this;
	            if (document.visibilityState === 'visible') {
	                setTimeout(function() {
	                    that.layout();
	                }, 500);
	
	            }
	        },
	
	        applyFilter: function (e) {
	            if (typeof e != 'undefined' && typeof e.preventDefault == "function")
	                e.preventDefault();
	
	            var link = $(e.target);
	            if (!link.length)
	                link = link.parents('a');
	
	            if (link.hasClass('active'))
	                return;
	
	            this.filter.find('a').removeClass('active');
	            link.addClass('active');
	
	            var filter = link.attr('data-filter');
	
	            this.filterChosen = filter ? filter : '';
	            this.loadNewItems(true);
	
	            this.filterdropdown.trigger('dropdown:close');
	        },
	
	        layout: function () {
	            //number of columns depend on current screen size
	            var width = this.grid.outerWidth(),
	                current = {
	                    x: 0,
	                    y: 0,
	                    ymax: 0
	                },
	                counter = 0;
	
	            this.bigItems = this.items.filter('[data-size=' + this.settings.sizeBig + ']').toArray();
	            this.wideItems = this.items.filter('[data-size=' + this.settings.sizeWide + ']').toArray();
	            this.smallItems = this.items.filter('[data-size=' + this.settings.sizeSmall + ']').toArray();
	
	            this.items.css({
	                position: 'absolute',
	                display: ''
	            });
	
	            while (this.bigItems.length || this.wideItems.length || this.smallItems.length) {
	                var type = this.template[counter % this.template.length];
	                current = this.setItem[type].call(this, current, width);
	                counter++;
	            }
	
	            TweenMax.fromTo(this.grid, 0.5, { height: this.grid.outerHeight() }, { height: current.ymax });
	
	
	            var texts = this.grid.find('.feed__item-text');
	            texts.filter('.js-dotted').trigger("destroy");
	            texts.addClass('js-dotted');
	            texts.dotdotdot();
	        },
	
	        setItem: {
	            'single': function (current, width) {
	                if (!this.bigItems.length)
	                    return this.setItem['quaternary'].call(this, current, width);
	
	                var item = $(this.bigItems.splice(0, 1)),
	                    itemWidth = item.outerWidth(true),
	                    itemHeight = item.outerHeight(true);
	
	                item.css({
	                    top: current.y + 'px',
	                    left: current.x + 'px'
	                });
	
	                return this.increaseCurrent(current, width, itemWidth, itemHeight);
	            },
	            'double': function (current, width) {
	                if (this.smallItems.length >= 2 && this.wideItems.length) {
	                    return this.setItem['triple'].call(this, current, width);
	                } else if (this.wideItems.length < 2 && this.bigItems.length) {
	                    return this.setItem['single'].call(this, current, width);
	                } if (!this.wideItems.length) {
	                    return this.setItem['quaternary'].call(this, current, width);
	                }
	
	                var items = this.wideItems.splice(0, 2),
	                    itemWidth = $(items[0]).outerWidth(true),
	                    itemHeight = $(items[0]).outerHeight(true);
	
	                for (var i = 0, l = items.length; i < l; i++) {
	                    $(items[i]).css({
	                        top: current.y + i * itemHeight + 'px',
	                        left: current.x + 'px'
	                    });
	                }
	
	                return this.increaseCurrent(current, width, itemWidth, items.length==1 ? itemHeight : itemHeight * 2);
	
	            },
	            'triple': function (current, width, reversed) {
	                if (this.smallItems.length < 2 && this.wideItems.length >= 2) {
	                    return this.setItem['double'].call(this, current, width);
	                }
	                if (!this.wideItems.length) {
	                    return this.setItem['quaternary'].call(this, current, width);
	                }
	
	                var items = this.smallItems.splice(0, 2),
	                    wideItem = $(this.wideItems.splice(0, 1)),
	                    itemWidth = $(items[0]).outerWidth(true) || wideItem.outerWidth(true)/2,
	                    itemHeight = $(items[0]).outerHeight(true) || wideItem.outerHeight(true);
	
	                wideItem.css({
	                    top: current.y + (reversed && items.length ? itemHeight : 0 ) + 'px',
	                    left: current.x + 'px'
	                });
	
	                for (var i = 0, l = items.length; i < l; i++) {
	                    $(items[i]).css({
	                        top: current.y + (reversed ? 0 : itemHeight) + 'px',
	                        left: current.x + itemWidth*i + 'px'
	                    });
	                }
	
	                return this.increaseCurrent(current, width, itemWidth * 2, !items.length ? itemHeight : itemHeight * 2);
	
	            },
	            'tripleReversed': function (current, width) {
	                return this.setItem['triple'].call(this, current, width, true);
	            },
	            'quaternary': function (current, width) {
	                if (this.smallItems.length < 4) {
	                    if (this.wideItems.length && this.smallItems.length >= 2)
	                        return this.setItem['triple'].call(this, current, width);
	                    else if (this.wideItems.length > 1) {
	                        return this.setItem['double'].call(this, current, width);
	                    } else if (this.bigItems.length) {
	                        return this.setItem['single'].call(this, current, width);
	                    } else if (!this.smallItems.length) {
	                        return current;
	                    }
	                }
	
	                var items = this.smallItems.splice(0, 4),
	                    itemWidth = $(items[0]).outerWidth(true),
	                    itemHeight = $(items[0]).outerHeight(true);
	
	
	                for (var i = 0, l = items.length; i < l; i++) {
	                    $(items[i]).css({
	                        top: current.y + itemHeight*(i<2 ? 0 : 1) + 'px',
	                        left: current.x + itemWidth * (i % 2) + 'px'
	                    });
	                }
	
	                return this.increaseCurrent(current, width, itemWidth * 2, items.length <=2 ? itemHeight : itemHeight * 2);
	            }
	
	        },
	        increaseCurrent: function (current, width, itemWidth, itemHeight) {
	            current.x = current.x + itemWidth;
	
	            if (current.x >= width - 1) {
	                current.ymax = Math.max(current.ymax, current.y + itemHeight);
	                current.x = 0;
	                current.y = current.ymax;
	            } else {
	                current.ymax = current.y + itemHeight;
	            }
	            return current;
	        },
	        loadNewItems: function (isnew, e) {
	            if (typeof e != 'undefined' && typeof e.preventDefault == "function")
	                e.preventDefault();
	
	            if (!this.settings.url.length)
	                return;
	
	            if (typeof isnew == 'undefined')
	                isnew = false;
	
	            if (isnew) {
	                this.settings.page = 1;
	            };
	
	            var data = {
	                page: this.settings.page,
	                bigCount: isnew ? 0 : this.items.filter('[data-size=' + this.settings.sizeBig + ']').length,
	                wideCount: isnew ? 0 : this.items.filter('[data-size=' + this.settings.sizeWide + ']').length,
	                smallCount: isnew ? 0 : this.items.filter('[data-size=' + this.settings.sizeSmall + ']').length
	            }
	
	            if (this.filterChosen.length) {
	                data["filter"] = this.filterChosen;
	            }
	
	            this.grid.addClass(isnew ? 'loading-all' : 'loading');
	            this.ajaxAbort();
	
	            this.ajaxCall = $.ajax({
	                method: "POST",
	                url: this.settings.url,
	                dataType: "json",
	                data: data,
	                success: this.ajaxSuccess.bind(this),
	                error: this.ajaxError.bind(this)
	            });
	
	        },
	        ajaxSuccess: function (data) {
	            var newDate = new Date(),
	                diff = newDate - this.ajaxTime;
	            if (diff < this.settings.mintimeout) {
	                setTimeout(this.ajaxSuccess.bind(this, data), this.settings.mintimeout - diff + 1);
	                return;
	            }
	
	            var isnew = this.grid.hasClass('loading-all'),
	                newPageId = data.page;
	            if (newPageId != this.settings.page + 1)
	                return;
	            this.settings.page = newPageId;
	            if (typeof data.total != 'undefined')
	                this.settings.total = data.total;
	
	            this.grid.removeClass('loading loading-all');
	
	
	            this.grid[isnew ? 'html' : 'append']($(this.handlebarsTempalteCompiled(data)));
	            this.items = this.grid.children();
	            this.afterContentUpdate();
	
	            this.loadmoreCheck();
	            this.layout();
	            this.translateText();
	        },
	
	        ajaxError: function () {
	            this.grid.removeClass('loading loading-all');
	        },
	
	        ajaxAbort: function () {
	            if (this.ajaxCall && typeof this.ajaxCall.abort == "function") {
	                try {
	                    ajaxCall.abort();
	                } catch (ex) { }
	            }
	            if (this.ajaxTimeout)
	                clearTimeout(ajaxTimeout);
	            this.ajaxTime = new Date();
	        },
	        loadmoreCheck: function () {
	            if (this.settings.page > this.settings.total) {
	                this.loadmore.hide();
	            } else {
	                this.loadmore.show();
	            }
	        },
	        afterContentUpdate: function () {
	            $(window).trigger('video:init');
	        },
	        translateText: function () {
	            var $translateElemList = $('.js-translate');
	            var arrElemToTranslate = [];
	            $translateElemList.each( function (i,e) {
	                e.classList.forEach( function (e) {
	                    if (e.match(/js-translate-/) && (arrElemToTranslate.indexOf(e) === -1)) arrElemToTranslate.push(e);
	                })
	            });
	
	            arrElemToTranslate.forEach( function (e) {
	                var $loadMoreElem = $('.' + e);
	                var loadMoreText = '';
	                $loadMoreElem.each( function (i, e) {
	                    if (e.innerText) {
	                        if (!e.innerText.match(/^\{\$/)) loadMoreText = e.innerText;
	                        else e.innerText = loadMoreText;
	                    }
	                });
	            });
	        }
	    });
	
	    return socialfeed
	
	}));


/***/ },

/***/ 91:
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/**
	 * Social Likes
	 * http://sapegin.github.com/social-likes
	 *
	 * Sharing buttons for Russian and worldwide social networks.
	 *
	 * @requires jQuery
	 * @author Artem Sapegin
	 * @copyright 2014 Artem Sapegin (sapegin.me)
	 * @license MIT
	 */
	
	/*global define:false, socialLikesButtons:false */
	
	(function(factory) {  // Try to register as an anonymous AMD module
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else {
			factory(jQuery);
		}
	}(function($, undefined) {
	
		'use strict';
	
		var prefix = 'social-likes';
		var classPrefix = prefix + '__';
		var openClass = prefix + '_opened';
		var protocol = location.protocol === 'https:' ? 'https:' : 'http:';
		var isHttps = protocol === 'https:';
	
	
		/**
		 * Buttons
		 */
		var services = {
			facebook: {
				// https://developers.facebook.com/docs/reference/fql/link_stat/
				counterUrl: 'https://graph.facebook.com/fql?q=SELECT+total_count+FROM+link_stat+WHERE+url%3D%22{url}%22&callback=?',
				convertNumber: function(data) {
					return data.data[0].total_count;
				},
				popupUrl: 'https://www.facebook.com/sharer/sharer.php?u={url}',
				popupWidth: 600,
				popupHeight: 359
			},
			twitter: {
				popupUrl: 'https://twitter.com/intent/tweet?url={url}&text={title}',
				popupWidth: 600,
				popupHeight: 250,
				click: function() {
					// Add colon to improve readability
					if (!/[\.\?:\-–—]\s*$/.test(this.options.title)) this.options.title += ':';
					return true;
				}
			},
			mailru: {
				counterUrl: protocol + '//connect.mail.ru/share_count?url_list={url}&callback=1&func=?',
				convertNumber: function(data) {
					for (var url in data) {
						if (data.hasOwnProperty(url)) {
							return data[url].shares;
						}
					}
				},
				popupUrl: 'https://connect.mail.ru/share?share_url={url}&title={title}',
				popupWidth: 492,
				popupHeight: 500
			},
			vkontakte: {
				counterUrl: 'https://vk.com/share.php?act=count&url={url}&index={index}',
				counter: function(jsonUrl, deferred) {
					var options = services.vkontakte;
					if (!options._) {
						options._ = [];
						if (!window.VK) window.VK = {};
						window.VK.Share = {
							count: function(idx, number) {
								options._[idx].resolve(number);
							}
						};
					}
	
					var index = options._.length;
					options._.push(deferred);
					$.getScript(makeUrl(jsonUrl, {index: index}))
						.fail(deferred.reject);
				},
				popupUrl: 'https://vk.com/share.php?url={url}&title={title}',
				popupWidth: 655,
				popupHeight: 450
			},
			odnoklassniki: {
				counterUrl: protocol + '//connect.ok.ru/dk?st.cmd=extLike&ref={url}&uid={index}',
				counter: function(jsonUrl, deferred) {
					var options = services.odnoklassniki;
					if (!options._) {
						options._ = [];
						if (!window.ODKL) window.ODKL = {};
						window.ODKL.updateCount = function(idx, number) {
							options._[idx].resolve(number);
						};
					}
	
					var index = options._.length;
					options._.push(deferred);
					$.getScript(makeUrl(jsonUrl, {index: index}))
						.fail(deferred.reject);
				},
				popupUrl: 'https://connect.ok.ru/dk?st.cmd=WidgetSharePreview&service=odnoklassniki&st.shareUrl={url}',
				popupWidth: 580,
				popupHeight: 336
			},
			plusone: {
				counterUrl: protocol + '//share.yandex.ru/gpp.xml?url={url}&callback=?',
				convertNumber: function(number) {
					return parseInt(number.replace(/\D/g, ''), 10);
				},
				popupUrl: 'https://plus.google.com/share?url={url}',
				popupWidth: 500,
				popupHeight: 550
			},
			pinterest: {
				counterUrl: protocol + '//api.pinterest.com/v1/urls/count.json?url={url}&callback=?',
				convertNumber: function(data) {
					return data.count;
				},
				popupUrl: 'https://pinterest.com/pin/create/button/?url={url}&description={title}',
				popupWidth: 740,
				popupHeight: 550
			}
		};
	
	
		/**
		 * Counters manager
		 */
		var counters = {
			promises: {},
			fetch: function(service, url, extraOptions) {
				if (!counters.promises[service]) counters.promises[service] = {};
				var servicePromises = counters.promises[service];
	
				if (!extraOptions.forceUpdate && servicePromises[url]) {
					return servicePromises[url];
				}
				else {
					var options = $.extend({}, services[service], extraOptions);
					var deferred = $.Deferred();
					var jsonUrl = options.counterUrl && makeUrl(options.counterUrl, {url: url});
	
					if (jsonUrl && $.isFunction(options.counter)) {
						options.counter(jsonUrl, deferred);
					}
					else if (options.counterUrl) {
						$.getJSON(jsonUrl)
							.done(function(data) {
								try {
									var number = data;
									if ($.isFunction(options.convertNumber)) {
										number = options.convertNumber(data);
									}
									deferred.resolve(number);
								}
								catch (e) {
									deferred.reject();
								}
							})
							.fail(deferred.reject);
					}
					else {
						deferred.reject();
					}
	
					servicePromises[url] = deferred.promise();
					return servicePromises[url];
				}
			}
		};
	
	
		/**
		 * jQuery plugin
		 */
		$.fn.socialLikes = function(options) {
			return this.each(function() {
				var elem = $(this);
				var instance = elem.data(prefix);
				if (instance) {
					if ($.isPlainObject(options)) {
						instance.update(options);
					}
				}
				else {
					instance = new SocialLikes(elem, $.extend({}, $.fn.socialLikes.defaults, options, dataToOptions(elem)));
					elem.data(prefix, instance);
				}
			});
		};
	
		$.fn.socialLikes.defaults = {
			url: window.location.href.replace(window.location.hash, ''),
			title: document.title,
			counters: true,
			zeroes: false,
			wait: 500,  // Show buttons only after counters are ready or after this amount of time
			timeout: 10000,  // Show counters after this amount of time even if they aren’t ready
			popupCheckInterval: 500,
			singleTitle: 'Share'
		};
	
		function SocialLikes(container, options) {
			this.container = container;
			this.options = options;
			this.init();
		}
	
		SocialLikes.prototype = {
			init: function() {
				// Add class in case of manual initialization
				this.container.addClass(prefix);
	
				this.single = this.container.hasClass(prefix + '_single');
	
				this.initUserButtons();
	
				this.countersLeft = 0;
				this.number = 0;
				this.container.on('counter.' + prefix, $.proxy(this.updateCounter, this));
	
				var buttons = this.container.children();
	
				this.makeSingleButton();
	
				this.buttons = [];
				buttons.each($.proxy(function(idx, elem) {
					var button = new Button($(elem), this.options);
					this.buttons.push(button);
					if (button.options.counterUrl) this.countersLeft++;
				}, this));
	
				if (this.options.counters) {
					this.timer = setTimeout($.proxy(this.appear, this), this.options.wait);
					this.timeout = setTimeout($.proxy(this.ready, this, true), this.options.timeout);
				}
				else {
					this.appear();
				}
			},
			initUserButtons: function() {
				if (!this.userButtonInited && window.socialLikesButtons) {
					$.extend(true, services, socialLikesButtons);
				}
				this.userButtonInited = true;
			},
			makeSingleButton: function() {
				if (!this.single) return;
	
				var container = this.container;
				container.addClass(prefix + '_vertical');
				container.wrap($('<div>', {'class': prefix + '_single-w'}));
				container.wrapInner($('<div>', {'class': prefix + '__single-container'}));
				var wrapper = container.parent();
	
				// Widget
				var widget = $('<div>', {
					'class': getElementClassNames('widget', 'single')
				});
				var button = $(template(
					'<div class="{buttonCls}">' +
						'<span class="{iconCls}"></span>' +
						'{title}' +
					'</div>',
					{
						buttonCls: getElementClassNames('button', 'single'),
						iconCls: getElementClassNames('icon', 'single'),
						title: this.options.singleTitle
					}
				));
				widget.append(button);
				wrapper.append(widget);
	
				widget.on('click', function() {
					var activeClass = prefix + '__widget_active';
					widget.toggleClass(activeClass);
					if (widget.hasClass(activeClass)) {
						container.css({left: -(container.width()-widget.width())/2,  top: -container.height()});
						showInViewport(container);
						closeOnClick(container, function() {
							widget.removeClass(activeClass);
						});
					}
					else {
						container.removeClass(openClass);
					}
					return false;
				});
	
				this.widget = widget;
			},
			update: function(options) {
				if (!options.forceUpdate && options.url === this.options.url) return;
	
				// Reset counters
				this.number = 0;
				this.countersLeft = this.buttons.length;
				if (this.widget) this.widget.find('.' + prefix + '__counter').remove();
	
				// Update options
				$.extend(this.options, options);
				for (var buttonIdx = 0; buttonIdx < this.buttons.length; buttonIdx++) {
					this.buttons[buttonIdx].update(options);
				}
			},
			updateCounter: function(e, service, number) {
				number = number || 0;
	
				if (number || this.options.zeroes) {
					this.number += number;
					if (this.single) {
						this.getCounterElem().text(this.number);
					}
				}
	
				if (this.countersLeft === 0) {
					this.appear();
					this.ready();
				}
				this.countersLeft--;
			},
			appear: function() {
				this.container.addClass(prefix + '_visible');
			},
			ready: function(silent) {
				if (this.timeout) {
					clearTimeout(this.timeout);
				}
				this.container.addClass(prefix + '_ready');
				if (!silent) {
					this.container.trigger('ready.' + prefix, this.number);
				}
			},
			getCounterElem: function() {
				var counterElem = this.widget.find('.' + classPrefix + 'counter_single');
				if (!counterElem.length) {
					counterElem = $('<span>', {
						'class': getElementClassNames('counter', 'single')
					});
					this.widget.append(counterElem);
				}
				return counterElem;
			}
		};
	
	
		function Button(widget, options) {
			this.widget = widget;
			this.options = $.extend({}, options);
			this.detectService();
			if (this.service) {
				this.init();
			}
		}
	
		Button.prototype = {
			init: function() {
				this.detectParams();
				this.initHtml();
				setTimeout($.proxy(this.initCounter, this), 0);
			},
	
			update: function(options) {
				$.extend(this.options, {forceUpdate: false}, options);
				this.widget.find('.' + prefix + '__counter').remove();  // Remove old counter
				this.initCounter();
			},
	
			detectService: function() {
				var service = this.widget.data('service');
				if (!service) {
					// class="facebook"
					var node = this.widget[0];
					var classes = node.classList || node.className.split(' ');
					for (var classIdx = 0; classIdx < classes.length; classIdx++) {
						var cls = classes[classIdx];
						if (services[cls]) {
							service = cls;
							break;
						}
					}
					if (!service) return;
				}
				this.service = service;
				$.extend(this.options, services[service]);
			},
	
			detectParams: function() {
				var data = this.widget.data();
	
				// Custom page counter URL or number
				if (data.counter) {
					var number = parseInt(data.counter, 10);
					if (isNaN(number)) {
						this.options.counterUrl = data.counter;
					}
					else {
						this.options.counterNumber = number;
					}
				}
	
				// Custom page title
				if (data.title) {
					this.options.title = data.title;
				}
	
				// Custom page URL
				if (data.url) {
					this.options.url = data.url;
				}
			},
	
			initHtml: function() {
				var options = this.options;
				var widget = this.widget;
	
				// Old initialization HTML
				var a = widget.find('a');
				if (a.length) {
					this.cloneDataAttrs(a, widget);
				}
	
				// Button
				var button = $('<span>', {
					'class': this.getElementClassNames('button'),
					'text': widget.text()
				});
				if (options.clickUrl) {
					var url = makeUrl(options.clickUrl, {
						url: options.url,
						title: options.title
					});
					var link = $('<a>', {
						href: url
					});
					this.cloneDataAttrs(widget, link);
					widget.replaceWith(link);
					this.widget = widget = link;
				}
				else {
					widget.on('click', $.proxy(this.click, this));
				}
	
				widget.removeClass(this.service);
				widget.addClass(this.getElementClassNames('widget'));
	
				// Icon
				button.prepend($('<span>', {'class': this.getElementClassNames('icon')}));
	
				widget.empty().append(button);
				this.button = button;
			},
	
			initCounter: function() {
				if (this.options.counters) {
					if (this.options.counterNumber) {
						this.updateCounter(this.options.counterNumber);
					}
					else {
						var extraOptions = {
							counterUrl: this.options.counterUrl,
							forceUpdate: this.options.forceUpdate
						};
						counters.fetch(this.service, this.options.url, extraOptions)
							.always($.proxy(this.updateCounter, this));
					}
				}
			},
	
			cloneDataAttrs: function(source, destination) {
				var data = source.data();
				for (var key in data) {
					if (data.hasOwnProperty(key)) {
						destination.data(key, data[key]);
					}
				}
			},
	
			getElementClassNames: function(elem) {
				return getElementClassNames(elem, this.service);
			},
	
			updateCounter: function(number) {
				number = parseInt(number, 10) || 0;
	
				var params = {
					'class': this.getElementClassNames('counter'),
					'text': number
				};
				if (!number && !this.options.zeroes) {
					params['class'] += ' ' + prefix + '__counter_empty';
					params.text = '';
				}
				var counterElem = $('<span>', params);
				this.widget.append(counterElem);
	
				this.widget.trigger('counter.' + prefix, [this.service, number]);
			},
	
			click: function(e) {
				var options = this.options;
				var process = true;
				if ($.isFunction(options.click)) {
					process = options.click.call(this, e);
				}
				if (process) {
					var url = makeUrl(options.popupUrl, {
						url: options.url,
						title: options.title
					});
					url = this.addAdditionalParamsToUrl(url);
					this.openPopup(url, {
						width: options.popupWidth,
						height: options.popupHeight
					});
				}
				return false;
			},
	
			addAdditionalParamsToUrl: function(url) {
				var params = $.param($.extend(this.widget.data(), this.options.data));
				if ($.isEmptyObject(params)) return url;
				var glue = url.indexOf('?') === -1 ? '?' : '&';
				return url + glue + params;
			},
	
			openPopup: function(url, params) {
				var left = Math.round(screen.width/2 - params.width/2);
				var top = 0;
				if (screen.height > params.height) {
					top = Math.round(screen.height/3 - params.height/2);
				}
	
				var win = window.open(url, 'sl_' + this.service, 'left=' + left + ',top=' + top + ',' +
				   'width=' + params.width + ',height=' + params.height + ',personalbar=0,toolbar=0,scrollbars=1,resizable=1');
				if (win) {
					win.focus();
					this.widget.trigger('popup_opened.' + prefix, [this.service, win]);
					var timer = setInterval($.proxy(function() {
						if (!win.closed) return;
						clearInterval(timer);
						this.widget.trigger('popup_closed.' + prefix, this.service);
					}, this), this.options.popupCheckInterval);
				}
				else {
					location.href = url;
				}
			}
		};
	
	
		/**
		 * Helpers
		 */
	
		 // Camelize data-attributes
		function dataToOptions(elem) {
			function upper(m, l) {
				return l.toUpper();
			}
			var options = {};
			var data = elem.data();
			for (var key in data) {
				var value = data[key];
				if (value === 'yes') value = true;
				else if (value === 'no') value = false;
				options[key.replace(/-(\w)/g, upper)] = value;
			}
			return options;
		}
	
		function makeUrl(url, context) {
			return template(url, context, encodeURIComponent);
		}
	
		function template(tmpl, context, filter) {
			return tmpl.replace(/\{([^\}]+)\}/g, function(m, key) {
				// If key doesn't exists in the context we should keep template tag as is
				return key in context ? (filter ? filter(context[key]) : context[key]) : m;
			});
		}
	
		function getElementClassNames(elem, mod) {
			var cls = classPrefix + elem;
			return cls + ' ' + cls + '_' + mod;
		}
	
		function closeOnClick(elem, callback) {
			function handler(e) {
				if ((e.type === 'keydown' && e.which !== 27) || $(e.target).closest(elem).length) return;
				elem.removeClass(openClass);
				doc.off(events, handler);
				if ($.isFunction(callback)) callback();
			}
			var doc = $(document);
			var events = 'click touchstart keydown';
			doc.on(events, handler);
		}
	
		function showInViewport(elem) {
			var offset = 10;
			if (document.documentElement.getBoundingClientRect) {
				var left = parseInt(elem.css('left'), 10);
				var top = parseInt(elem.css('top'), 10);
	
				var rect = elem[0].getBoundingClientRect();
				if (rect.left < offset)
					elem.css('left', offset - rect.left + left);
				else if (rect.right > window.innerWidth - offset)
					elem.css('left', window.innerWidth - rect.right - offset + left);
	
				if (rect.top < offset)
					elem.css('top', offset - rect.top + top);
				else if (rect.bottom > window.innerHeight - offset)
					elem.css('top', window.innerHeight - rect.bottom - offset + top);
			}
			elem.addClass(openClass);
		}
	
	
		/**
		 * Auto initialization
		 */
		$(function() {
			$('.' + prefix).socialLikes();
		});
	
	}));


/***/ },

/***/ 106:
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(8);
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, options, buffer = "";
	
	  stack1 = ((helper = (helper = helpers.LinkTitle || (depth0 != null ? depth0.LinkTitle : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"LinkTitle","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},options) : helper));
	  if (!helpers.LinkTitle) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  return buffer;
	},"2":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "            <div class=\"cookie-bar__table-cell\">\r\n                <strong>\r\n                    <a href=\""
	    + alias4(((helper = (helper = helpers.LinkUrl || (depth0 != null ? depth0.LinkUrl : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"LinkUrl","hash":{},"data":data}) : helper)))
	    + "\"\r\n                       target=\"_blank\"\r\n                       data-tracking-category=\"Cookie Policy\"\r\n                       data-tracking-action=\"Button\"\r\n                       data-tracking-label=\""
	    + alias4(((helper = (helper = helpers.LinkTitle || (depth0 != null ? depth0.LinkTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"LinkTitle","hash":{},"data":data}) : helper)))
	    + "\">"
	    + alias4(((helper = (helper = helpers.LinkTitle || (depth0 != null ? depth0.LinkTitle : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"LinkTitle","hash":{},"data":data}) : helper)))
	    + "</a>\r\n                </strong>\r\n            </div>\r\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, options, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", buffer = 
	  "<div class=\"cookie-bar js-cookie-bar\">\r\n    <div class=\"container\">\r\n        <div class=\"cookie-bar__table\">\r\n            <div class=\"cookie-bar__table-cell\">\r\n                <div class=\"cookie-bar__content\">\r\n                    "
	    + container.escapeExpression(((helper = (helper = helpers.Text || (depth0 != null ? depth0.Text : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Text","hash":{},"data":data}) : helper)))
	    + "\r\n                </div>\r\n            </div>\r\n";
	  stack1 = ((helper = (helper = helpers.LinkUrl || (depth0 != null ? depth0.LinkUrl : depth0)) != null ? helper : alias2),(options={"name":"LinkUrl","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.LinkUrl) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  return buffer + "            <div class=\"cookie-bar__table-cell\">\r\n                <a class=\"button button_orange button_small js-close-cookie-bar js-tracked\"\r\n                   data-tracking-category=\"Cookie Policy\"\r\n                   data-tracking-action=\"Button\"\r\n                   data-tracking-label=\"I accept\">{$MasterPage.CookiesNotification.AcceptButtonText$}</a>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n";
	},"useData":true});

/***/ },

/***/ 107:
/***/ function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(8);
	module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, options, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=helpers.blockHelperMissing, buffer = "";
	
	  stack1 = ((helper = (helper = helpers.IsYoutube || (depth0 != null ? depth0.IsYoutube : depth0)) != null ? helper : alias2),(options={"name":"IsYoutube","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsYoutube) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  stack1 = ((helper = (helper = helpers.IsTwitter || (depth0 != null ? depth0.IsTwitter : depth0)) != null ? helper : alias2),(options={"name":"IsTwitter","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsTwitter) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  stack1 = ((helper = (helper = helpers.IsFacebook || (depth0 != null ? depth0.IsFacebook : depth0)) != null ? helper : alias2),(options={"name":"IsFacebook","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsFacebook) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  stack1 = ((helper = (helper = helpers.IsBlogPost || (depth0 != null ? depth0.IsBlogPost : depth0)) != null ? helper : alias2),(options={"name":"IsBlogPost","hash":{},"fn":container.program(8, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsBlogPost) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  stack1 = ((helper = (helper = helpers.IsFeefo || (depth0 != null ? depth0.IsFeefo : depth0)) != null ? helper : alias2),(options={"name":"IsFeefo","hash":{},"fn":container.program(28, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsFeefo) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  stack1 = ((helper = (helper = helpers.IsGetAQuote || (depth0 != null ? depth0.IsGetAQuote : depth0)) != null ? helper : alias2),(options={"name":"IsGetAQuote","hash":{},"fn":container.program(30, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsGetAQuote) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  return buffer;
	},"2":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "        <div class=\"grid__item grid__item_span_2 grid__item_tabletspan_4\" data-size=\"small\">\r\n            <div class=\"feed__item\">\r\n            <div class=\"feed__item-content\">\r\n                <div class=\"feed__item-title\">\r\n                    <div class=\"video-module__wrapper\">\r\n                        <a href=\""
	    + alias4(((helper = (helper = helpers.Url || (depth0 != null ? depth0.Url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Url","hash":{},"data":data}) : helper)))
	    + "\" target=\"_blank\" class=\"video-module is-video-link\" data-title=\""
	    + alias4(((helper = (helper = helpers.Title || (depth0 != null ? depth0.Title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Title","hash":{},"data":data}) : helper)))
	    + "\" data-video-id=\""
	    + alias4(((helper = (helper = helpers.VideoId || (depth0 != null ? depth0.VideoId : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"VideoId","hash":{},"data":data}) : helper)))
	    + "\" style=\"background-image:url(//img.youtube.com/vi/"
	    + alias4(((helper = (helper = helpers.VideoId || (depth0 != null ? depth0.VideoId : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"VideoId","hash":{},"data":data}) : helper)))
	    + "/0.jpg)\" rel=\"nofollow\">\r\n                            <span class=\"button button_play\"></span>\r\n                        </a>\r\n                    </div>\r\n                </div>\r\n                <a href=\""
	    + alias4(((helper = (helper = helpers.Url || (depth0 != null ? depth0.Url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Url","hash":{},"data":data}) : helper)))
	    + "\" class=\"feed__item-text feed__item-text-youtube\" target=\"_blank\" rel=\"nofollow\">"
	    + alias4(((helper = (helper = helpers.Title || (depth0 != null ? depth0.Title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Title","hash":{},"data":data}) : helper)))
	    + "</a>\r\n                <div class=\"feed__item-footer\">"
	    + alias4(((helper = (helper = helpers.DateCreatedFormatted || (depth0 != null ? depth0.DateCreatedFormatted : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"DateCreatedFormatted","hash":{},"data":data}) : helper)))
	    + "</div>\r\n            </div>\r\n            </div>\r\n        </div>\r\n";
	},"4":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "        <div class=\"grid__item grid__item_span_2 grid__item_tabletspan_4\" data-size=\"small\">\r\n            <a href=\""
	    + alias4(((helper = (helper = helpers.Url || (depth0 != null ? depth0.Url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Url","hash":{},"data":data}) : helper)))
	    + "\" class=\"feed__item\" rel=\"nofollow\">\r\n            <span class=\"feed__item-content\">\r\n                <span class=\"feed__item-title\"><svg class=\"icon-twitter_small first\"><use xlink:href=\"#icon-twitter_small\"></use></svg></span>\r\n                <span class=\"feed__item-text\">"
	    + ((stack1 = ((helper = (helper = helpers.Content || (depth0 != null ? depth0.Content : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Content","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "</span>\r\n                <span class=\"feed__item-footer\">"
	    + alias4(((helper = (helper = helpers.DateCreatedFormatted || (depth0 != null ? depth0.DateCreatedFormatted : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"DateCreatedFormatted","hash":{},"data":data}) : helper)))
	    + "</span>\r\n            </span>\r\n            </a>\r\n        </div>\r\n";
	},"6":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "        <div class=\"grid__item grid__item_span_2 grid__item_tabletspan_4\" data-size=\"small\">\r\n            <a href=\""
	    + alias4(((helper = (helper = helpers.Url || (depth0 != null ? depth0.Url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Url","hash":{},"data":data}) : helper)))
	    + "\" class=\"feed__item\" rel=\"nofollow\">\r\n            <span class=\"feed__item-content\">\r\n                <span class=\"feed__item-title\"><svg class=\"icon-facebook_small first\"><use xlink:href=\"#icon-facebook_small\"></use></svg></span>\r\n                <span class=\"feed__item-text\">"
	    + ((stack1 = ((helper = (helper = helpers.Content || (depth0 != null ? depth0.Content : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Content","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "</span>\r\n                <span class=\"feed__item-footer\">"
	    + alias4(((helper = (helper = helpers.DateCreatedFormatted || (depth0 != null ? depth0.DateCreatedFormatted : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"DateCreatedFormatted","hash":{},"data":data}) : helper)))
	    + "</span>\r\n            </span>\r\n            </a>\r\n        </div>\r\n";
	},"8":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, options, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=helpers.blockHelperMissing, buffer = 
	  "    <div class=\"grid__item grid__item_span_4 grid__item_tabletspan_8\" data-size=\"";
	  stack1 = ((helper = (helper = helpers.IsBlogPostBig || (depth0 != null ? depth0.IsBlogPostBig : depth0)) != null ? helper : alias2),(options={"name":"IsBlogPostBig","hash":{},"fn":container.program(9, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsBlogPostBig) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  stack1 = ((helper = (helper = helpers.IsBlogPostBig || (depth0 != null ? depth0.IsBlogPostBig : depth0)) != null ? helper : alias2),(options={"name":"IsBlogPostBig","hash":{},"fn":container.noop,"inverse":container.program(11, data, 0),"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsBlogPostBig) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += "\">\r\n        <a href=\""
	    + container.escapeExpression(((helper = (helper = helpers.Url || (depth0 != null ? depth0.Url : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Url","hash":{},"data":data}) : helper)))
	    + "\" class=\"feed__item ";
	  stack1 = ((helper = (helper = helpers.IsBlogPostBig || (depth0 != null ? depth0.IsBlogPostBig : depth0)) != null ? helper : alias2),(options={"name":"IsBlogPostBig","hash":{},"fn":container.noop,"inverse":container.program(13, data, 0),"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsBlogPostBig) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += "\">\r\n";
	  stack1 = ((helper = (helper = helpers.HasImage || (depth0 != null ? depth0.HasImage : depth0)) != null ? helper : alias2),(options={"name":"HasImage","hash":{},"fn":container.program(15, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.HasImage) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += "            <span class=\"feed__item-content ";
	  stack1 = ((helper = (helper = helpers.IsBlogPostGreen || (depth0 != null ? depth0.IsBlogPostGreen : depth0)) != null ? helper : alias2),(options={"name":"IsBlogPostGreen","hash":{},"fn":container.program(18, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsBlogPostGreen) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  stack1 = ((helper = (helper = helpers.IsBlogPostBlue || (depth0 != null ? depth0.IsBlogPostBlue : depth0)) != null ? helper : alias2),(options={"name":"IsBlogPostBlue","hash":{},"fn":container.program(20, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsBlogPostBlue) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += "\">\r\n                <span class=\"feed__item-title\">\r\n";
	  stack1 = ((helper = (helper = helpers.HasTitle || (depth0 != null ? depth0.HasTitle : depth0)) != null ? helper : alias2),(options={"name":"HasTitle","hash":{},"fn":container.program(22, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.HasTitle) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += "                </span>\r\n                <span class=\"feed__item-text\">";
	  stack1 = ((helper = (helper = helpers.IsBlogPostBig || (depth0 != null ? depth0.IsBlogPostBig : depth0)) != null ? helper : alias2),(options={"name":"IsBlogPostBig","hash":{},"fn":container.program(24, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsBlogPostBig) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  buffer += "</span>\r\n                <span class=\"feed__item-footer\"><span class=\"iconed-link iconed-link_underline\">\r\n                    <span class=\"js-translate js-translate-readmore\">\r\n                    ";
	  stack1 = ((helper = (helper = helpers.IsBlogPostBig || (depth0 != null ? depth0.IsBlogPostBig : depth0)) != null ? helper : alias2),(options={"name":"IsBlogPostBig","hash":{},"fn":container.program(26, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsBlogPostBig) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  stack1 = ((helper = (helper = helpers.IsBlogPostBig || (depth0 != null ? depth0.IsBlogPostBig : depth0)) != null ? helper : alias2),(options={"name":"IsBlogPostBig","hash":{},"fn":container.noop,"inverse":container.program(24, data, 0),"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsBlogPostBig) { stack1 = alias4.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  return buffer + "</span>\r\n                    <svg class=\"last icon icon-arrow-right\"><use xlink:href=\"#icon-arrow-right\"></use></svg></span></span>\r\n            </span>\r\n        </a>\r\n    </div>\r\n";
	},"9":function(container,depth0,helpers,partials,data) {
	    return "big";
	},"11":function(container,depth0,helpers,partials,data) {
	    return "wide";
	},"13":function(container,depth0,helpers,partials,data) {
	    return "feed__item_half";
	},"15":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, options, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression, buffer = 
	  "            <span class=\"feed__item-image ";
	  stack1 = ((helper = (helper = helpers.IsBlogPostBlue || (depth0 != null ? depth0.IsBlogPostBlue : depth0)) != null ? helper : alias2),(options={"name":"IsBlogPostBlue","hash":{},"fn":container.program(16, data, 0),"inverse":container.noop,"data":data}),(typeof helper === alias3 ? helper.call(alias1,options) : helper));
	  if (!helpers.IsBlogPostBlue) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  return buffer + "\" style=\"background-image:url("
	    + alias4(((helper = (helper = helpers.ImageUrl || (depth0 != null ? depth0.ImageUrl : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ImageUrl","hash":{},"data":data}) : helper)))
	    + ")\"><img width=\"525\" height=\"525\" src=\""
	    + alias4(((helper = (helper = helpers.ImageUrl || (depth0 != null ? depth0.ImageUrl : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"ImageUrl","hash":{},"data":data}) : helper)))
	    + "\" /></span>\r\n";
	},"16":function(container,depth0,helpers,partials,data) {
	    return "feed__item-image_half";
	},"18":function(container,depth0,helpers,partials,data) {
	    return "feed__item-content_green";
	},"20":function(container,depth0,helpers,partials,data) {
	    return "feed__item-content_blue";
	},"22":function(container,depth0,helpers,partials,data) {
	    var helper;
	
	  return "                    "
	    + container.escapeExpression(((helper = (helper = helpers.Title || (depth0 != null ? depth0.Title : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"Title","hash":{},"data":data}) : helper)))
	    + "\r\n";
	},"24":function(container,depth0,helpers,partials,data) {
	    var stack1, helper;
	
	  return ((stack1 = ((helper = (helper = helpers.Content || (depth0 != null ? depth0.Content : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"Content","hash":{},"data":data}) : helper))) != null ? stack1 : "");
	},"26":function(container,depth0,helpers,partials,data) {
	    return "{$Blogs.BlogFeed.ReadFullArticleTitle$}";
	},"28":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : {}, alias2=helpers.helperMissing, alias3="function", alias4=container.escapeExpression;
	
	  return "    <div class=\"grid__item grid__item_span_4  grid__item_tabletspan_8\" data-size=\"wide\">\r\n        <div class=\"feed__item feed__item_half\">\r\n        <span class=\"feed__item-content feed__item-content_yellow\">\r\n            <span class=\"feed__item-title js-translate js-translate-feefotitle\">"
	    + alias4(((helper = (helper = helpers.Title || (depth0 != null ? depth0.Title : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Title","hash":{},"data":data}) : helper)))
	    + "</span>\r\n            <span class=\"feed__item-rating\">\r\n                <span>"
	    + alias4(((helper = (helper = helpers.Score || (depth0 != null ? depth0.Score : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Score","hash":{},"data":data}) : helper)))
	    + "</span><img alt=\"feefo\" src=\""
	    + alias4(((helper = (helper = helpers.RatingSystemLogo || (depth0 != null ? depth0.RatingSystemLogo : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"RatingSystemLogo","hash":{},"data":data}) : helper)))
	    + "\">\r\n            </span>\r\n            <span class=\"feed__item-text js-translate js-translate-feefotext\">\r\n                "
	    + alias4(((helper = (helper = helpers.Content || (depth0 != null ? depth0.Content : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"Content","hash":{},"data":data}) : helper)))
	    + "\r\n            </span>\r\n        </span>\r\n        </div>\r\n    </div>\r\n";
	},"30":function(container,depth0,helpers,partials,data) {
	    var stack1, helper;
	
	  return "        "
	    + ((stack1 = ((helper = (helper = helpers.RenderedHtml || (depth0 != null ? depth0.RenderedHtml : depth0)) != null ? helper : helpers.helperMissing),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},{"name":"RenderedHtml","hash":{},"data":data}) : helper))) != null ? stack1 : "")
	    + "\r\n";
	},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
	    var stack1, helper, options, buffer = "";
	
	  stack1 = ((helper = (helper = helpers.data || (depth0 != null ? depth0.data : depth0)) != null ? helper : helpers.helperMissing),(options={"name":"data","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : {},options) : helper));
	  if (!helpers.data) { stack1 = helpers.blockHelperMissing.call(depth0,stack1,options)}
	  if (stack1 != null) { buffer += stack1; }
	  return buffer;
	},"useData":true});

/***/ },

/***/ 127:
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/*** IMPORTS FROM imports-loader ***/
	(function() {
	
	/*
	 *	jQuery dotdotdot 1.7.4
	 *
	 *	Copyright (c) Fred Heusschen
	 *	www.frebsite.nl
	 *
	 *	Plugin website:
	 *	dotdotdot.frebsite.nl
	 *
	 *	Licensed under the MIT license.
	 *	http://en.wikipedia.org/wiki/MIT_License
	 */
	
	(function( $, undef )
	{
		if ( $.fn.dotdotdot )
		{
			return;
		}
	
		$.fn.dotdotdot = function( o )
		{
			if ( this.length == 0 )
			{
				$.fn.dotdotdot.debug( 'No element found for "' + this.selector + '".' );
				return this;
			}
			if ( this.length > 1 )
			{
				return this.each(
					function()
					{
						$(this).dotdotdot( o );
					}
				);
			}
	
	
			var $dot = this;
			var orgContent	= $dot.contents();
	
			if ( $dot.data( 'dotdotdot' ) )
			{
				$dot.trigger( 'destroy.dot' );
			}
	
			$dot.data( 'dotdotdot-style', $dot.attr( 'style' ) || '' );
			$dot.css( 'word-wrap', 'break-word' );
			if ($dot.css( 'white-space' ) === 'nowrap')
			{
				$dot.css( 'white-space', 'normal' );
			}
	
			$dot.bind_events = function()
			{
				$dot.bind(
					'update.dot',
					function( e, c )
					{
						$dot.removeClass("is-truncated");
						e.preventDefault();
						e.stopPropagation();
	
						switch( typeof opts.height )
						{
							case 'number':
								opts.maxHeight = opts.height;
								break;
	
							case 'function':
								opts.maxHeight = opts.height.call( $dot[ 0 ] );
								break;
	
							default:
								opts.maxHeight = getTrueInnerHeight( $dot );
								break;
						}
	
						opts.maxHeight += opts.tolerance;
	
						if ( typeof c != 'undefined' )
						{
							if ( typeof c == 'string' || ('nodeType' in c && c.nodeType === 1) )
							{
						 		c = $('<div />').append( c ).contents();
							}
							if ( c instanceof $ )
							{
								orgContent = c;
							}
						}
	
						$inr = $dot.wrapInner( '<div class="dotdotdot" />' ).children();
						$inr.contents()
							.detach()
							.end()
							.append( orgContent.clone( true ) )
							.find( 'br' )
							.replaceWith( '  <br />  ' )
							.end()
							.css({
								'height'	: 'auto',
								'width'		: 'auto',
								'border'	: 'none',
								'padding'	: 0,
								'margin'	: 0
							});
	
						var after = false,
							trunc = false;
	
						if ( conf.afterElement )
						{
							after = conf.afterElement.clone( true );
						    after.show();
							conf.afterElement.detach();
						}
	
						if ( test( $inr, opts ) )
						{
							if ( opts.wrap == 'children' )
							{
								trunc = children( $inr, opts, after );
							}
							else
							{
								trunc = ellipsis( $inr, $dot, $inr, opts, after );
							}
						}
						$inr.replaceWith( $inr.contents() );
						$inr = null;
	
						if ( $.isFunction( opts.callback ) )
						{
							opts.callback.call( $dot[ 0 ], trunc, orgContent );
						}
	
						conf.isTruncated = trunc;
						return trunc;
					}
	
				).bind(
					'isTruncated.dot',
					function( e, fn )
					{
						e.preventDefault();
						e.stopPropagation();
	
						if ( typeof fn == 'function' )
						{
							fn.call( $dot[ 0 ], conf.isTruncated );
						}
						return conf.isTruncated;
					}
	
				).bind(
					'originalContent.dot',
					function( e, fn )
					{
						e.preventDefault();
						e.stopPropagation();
	
						if ( typeof fn == 'function' )
						{
							fn.call( $dot[ 0 ], orgContent );
						}
						return orgContent;
					}
	
				).bind(
					'destroy.dot',
					function( e )
					{
						e.preventDefault();
						e.stopPropagation();
	
						$dot.unwatch()
							.unbind_events()
							.contents()
							.detach()
							.end()
							.append( orgContent )
							.attr( 'style', $dot.data( 'dotdotdot-style' ) || '' )
							.data( 'dotdotdot', false );
					}
				);
				return $dot;
			};	//	/bind_events
	
			$dot.unbind_events = function()
			{
				$dot.unbind('.dot');
				return $dot;
			};	//	/unbind_events
	
			$dot.watch = function()
			{
				$dot.unwatch();
				if ( opts.watch == 'window' )
				{
					var $window = $(window),
						_wWidth = $window.width(),
						_wHeight = $window.height();
	
					$window.bind(
						'resize.dot' + conf.dotId,
						function()
						{
							if ( _wWidth != $window.width() || _wHeight != $window.height() || !opts.windowResizeFix )
							{
								_wWidth = $window.width();
								_wHeight = $window.height();
	
								if ( watchInt )
								{
									clearInterval( watchInt );
								}
								watchInt = setTimeout(
									function()
									{
										$dot.trigger( 'update.dot' );
									}, 100
								);
							}
						}
					);
				}
				else
				{
					watchOrg = getSizes( $dot );
					watchInt = setInterval(
						function()
						{
							if ( $dot.is( ':visible' ) )
							{
								var watchNew = getSizes( $dot );
								if ( watchOrg.width  != watchNew.width ||
									 watchOrg.height != watchNew.height )
								{
									$dot.trigger( 'update.dot' );
									watchOrg = watchNew;
								}
							}
						}, 500
					);
				}
				return $dot;
			};
			$dot.unwatch = function()
			{
				$(window).unbind( 'resize.dot' + conf.dotId );
				if ( watchInt )
				{
					clearInterval( watchInt );
				}
				return $dot;
			};
	
			var	opts 		= $.extend( true, {}, $.fn.dotdotdot.defaults, o ),
				conf		= {},
				watchOrg	= {},
				watchInt	= null,
				$inr		= null;
	
	
			if ( !( opts.lastCharacter.remove instanceof Array ) )
			{
				opts.lastCharacter.remove = $.fn.dotdotdot.defaultArrays.lastCharacter.remove;
			}
			if ( !( opts.lastCharacter.noEllipsis instanceof Array ) )
			{
				opts.lastCharacter.noEllipsis = $.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis;
			}
	
	
			conf.afterElement	= getElement( opts.after, $dot );
			conf.isTruncated	= false;
			conf.dotId			= dotId++;
	
	
			$dot.data( 'dotdotdot', true )
				.bind_events()
				.trigger( 'update.dot' );
	
			if ( opts.watch )
			{
				$dot.watch();
			}
	
			return $dot;
		};
	
	
		//	public
		$.fn.dotdotdot.defaults = {
			'ellipsis'			: '... ',
			'wrap'				: 'word',
			'fallbackToLetter'	: true,
			'lastCharacter'		: {},
			'tolerance'			: 0,
			'callback'			: null,
			'after'				: null,
			'height'			: null,
			'watch'				: false,
			'windowResizeFix'	: true
		};
		$.fn.dotdotdot.defaultArrays = {
			'lastCharacter'		: {
				'remove'			: [ ' ', '\u3000', ',', ';', '.', '!', '?' ],
				'noEllipsis'		: []
			}
		};
		$.fn.dotdotdot.debug = function( msg ) {};
	
	
		//	private
		var dotId = 1;
	
		function children( $elem, o, after )
		{
			var $elements 	= $elem.children(),
				isTruncated	= false;
	
			$elem.empty();
	
			for ( var a = 0, l = $elements.length; a < l; a++ )
			{
				var $e = $elements.eq( a );
				$elem.append( $e );
				if ( after )
				{
					$elem.append( after );
				}
				if ( test( $elem, o ) )
				{
					$e.remove();
					isTruncated = true;
					break;
				}
				else
				{
					if ( after )
					{
						after.detach();
					}
				}
			}
			return isTruncated;
		}
		function ellipsis( $elem, $d, $i, o, after )
		{
			var isTruncated	= false;
	
			//	Don't put the ellipsis directly inside these elements
			var notx = 'a, table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style';
	
			//	Don't remove these elements even if they are after the ellipsis
			var noty = 'script, .dotdotdot-keep';
	
			$elem
				.contents()
				.detach()
				.each(
					function()
					{
	
						var e	= this,
							$e	= $(e);
	
						if ( typeof e == 'undefined' )
						{
							return true;
						}
						else if ( $e.is( noty ) )
						{
							$elem.append( $e );
						}
						else if ( isTruncated )
						{
							return true;
						}
						else
						{
							$elem.append( $e );
							if ( after && !$e.is( o.after ) && !$e.find( o.after ).length  )
							{
								$elem[ $elem.is( notx ) ? 'after' : 'append' ]( after );
							}
							if ( test( $i, o ) )
							{
								if ( e.nodeType == 3 ) // node is TEXT
								{
									isTruncated = ellipsisElement( $e, $d, $i, o, after );
								}
								else
								{
									isTruncated = ellipsis( $e, $d, $i, o, after );
								}
							}
	
							if ( !isTruncated )
							{
								if ( after )
								{
									after.detach();
								}
							}
						}
					}
				);
			$d.addClass("is-truncated");
			return isTruncated;
		}
		function ellipsisElement( $e, $d, $i, o, after )
		{
			var e = $e[ 0 ];
	
			if ( !e )
			{
				return false;
			}
	
			var txt			= getTextContent( e ),
				space		= ( txt.indexOf(' ') !== -1 ) ? ' ' : '\u3000',
				separator	= ( o.wrap == 'letter' ) ? '' : space,
				textArr		= txt.split( separator ),
				position 	= -1,
				midPos		= -1,
				startPos	= 0,
				endPos		= textArr.length - 1;
	
	
			//	Only one word
			if ( o.fallbackToLetter && startPos == 0 && endPos == 0 )
			{
				separator	= '';
				textArr		= txt.split( separator );
				endPos		= textArr.length - 1;
			}
	
			while ( startPos <= endPos && !( startPos == 0 && endPos == 0 ) )
			{
				var m = Math.floor( ( startPos + endPos ) / 2 );
				if ( m == midPos )
				{
					break;
				}
				midPos = m;
	
				setTextContent( e, textArr.slice( 0, midPos + 1 ).join( separator ) + o.ellipsis );
				$i.children()
					.each(
						function()
						{
							$(this).toggle().toggle();
						}
					);
	
				if ( !test( $i, o ) )
				{
					position = midPos;
					startPos = midPos;
				}
				else
				{
					endPos = midPos;
	
					//	Fallback to letter
					if (o.fallbackToLetter && startPos == 0 && endPos == 0 )
					{
						separator	= '';
						textArr		= textArr[ 0 ].split( separator );
						position	= -1;
						midPos		= -1;
						startPos	= 0;
						endPos		= textArr.length - 1;
					}
				}
			}
	
			if ( position != -1 && !( textArr.length == 1 && textArr[ 0 ].length == 0 ) )
			{
				txt = addEllipsis( textArr.slice( 0, position + 1 ).join( separator ), o );
				setTextContent( e, txt );
			}
			else
			{
				var $w = $e.parent();
				$e.detach();
	
				var afterLength = ( after && after.closest($w).length ) ? after.length : 0;
	
				if ( $w.contents().length > afterLength )
				{
					e = findLastTextNode( $w.contents().eq( -1 - afterLength ), $d );
				}
				else
				{
					e = findLastTextNode( $w, $d, true );
					if ( !afterLength )
					{
						$w.detach();
					}
				}
				if ( e )
				{
					txt = addEllipsis( getTextContent( e ), o );
					setTextContent( e, txt );
					if ( afterLength && after )
					{
						$(e).parent().append( after );
					}
				}
			}
	
			return true;
		}
		function test( $i, o )
		{
			return $i.innerHeight() > o.maxHeight;
		}
		function addEllipsis( txt, o )
		{
			while( $.inArray( txt.slice( -1 ), o.lastCharacter.remove ) > -1 )
			{
				txt = txt.slice( 0, -1 );
			}
			if ( $.inArray( txt.slice( -1 ), o.lastCharacter.noEllipsis ) < 0 )
			{
				txt += o.ellipsis;
			}
			return txt;
		}
		function getSizes( $d )
		{
			return {
				'width'	: $d.innerWidth(),
				'height': $d.innerHeight()
			};
		}
		function setTextContent( e, content )
		{
			if ( e.innerText )
			{
				e.innerText = content;
			}
			else if ( e.nodeValue )
			{
				e.nodeValue = content;
			}
			else if (e.textContent)
			{
				e.textContent = content;
			}
	
		}
		function getTextContent( e )
		{
			if ( e.innerText )
			{
				return e.innerText;
			}
			else if ( e.nodeValue )
			{
				return e.nodeValue;
			}
			else if ( e.textContent )
			{
				return e.textContent;
			}
			else
			{
				return "";
			}
		}
		function getPrevNode( n )
		{
			do
			{
				n = n.previousSibling;
			}
			while ( n && n.nodeType !== 1 && n.nodeType !== 3 );
	
			return n;
		}
		function findLastTextNode( $el, $top, excludeCurrent )
		{
			var e = $el && $el[ 0 ], p;
			if ( e )
			{
				if ( !excludeCurrent )
				{
					if ( e.nodeType === 3 )
					{
						return e;
					}
					if ( $.trim( $el.text() ) )
					{
						return findLastTextNode( $el.contents().last(), $top );
					}
				}
				p = getPrevNode( e );
				while ( !p )
				{
					$el = $el.parent();
					if ( $el.is( $top ) || !$el.length )
					{
						return false;
					}
					p = getPrevNode( $el[0] );
				}
				if ( p )
				{
					return findLastTextNode( $(p), $top );
				}
			}
			return false;
		}
		function getElement( e, $i )
		{
			if ( !e )
			{
				return false;
			}
			if ( typeof e === 'string' )
			{
				e = $(e, $i);
				return ( e.length )
					? e
					: false;
			}
			return !e.jquery
				? false
				: e;
		}
		function getTrueInnerHeight( $el )
		{
			var h = $el.innerHeight(),
				a = [ 'paddingTop', 'paddingBottom' ];
	
			for ( var z = 0, l = a.length; z < l; z++ )
			{
				var m = parseInt( $el.css( a[ z ] ), 10 );
				if ( isNaN( m ) )
				{
					m = 0;
				}
				h -= m;
			}
			return h;
		}
	
	
		//	override jQuery.html
		var _orgHtml = $.fn.html;
		$.fn.html = function( str )
		{
			if ( str != undef && !$.isFunction( str ) && this.data( 'dotdotdot' ) )
			{
				return this.trigger( 'update', [ str ] );
			}
			return _orgHtml.apply( this, arguments );
		};
	
	
		//	override jQuery.text
		var _orgText = $.fn.text;
		$.fn.text = function( str )
		{
			if ( str != undef && !$.isFunction( str ) && this.data( 'dotdotdot' ) )
			{
				str = $( '<div />' ).text( str ).html();
				return this.trigger( 'update', [ str ] );
			}
			return _orgText.apply( this, arguments );
		};
	
	
	})( jQuery );
	}.call(global));
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },

/***/ 247:
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./CookieNotificationTemplate.handlebars": 106,
		"./blogfeedtemplate.handlebars": 107
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 247;


/***/ }

});


/** WEBPACK FOOTER **
 ** chunk.blog.4b9c9c7f710248cd87bd.js
 **/